export default __webpack_public_path__ + "static/media/girar_celular_esp.7defd344.jpg";